<template>
  <section class="l-section wpb_row height_small mpc-row catalog">
    <div class="l-section-h catalog__inner">
      <div class="catalog__categories" :class="{_loading: pendingCategories}">
        <BasePreloader v-if="pendingCategories"/>
        <div class="catalog__categories-wrap">
          <router-link
            v-for="(item, index) in categories"
            :key="index"
            :to="{name: 'delivery', params: {restaurantId: $route.params.restaurantId, categorySlug: item.slug, savedPosition: true}}"
            :class="!$route.params.categorySlug && index === 0  ? '_active' : null"
            class="catalog__category-btn">
            <span>{{ item.name }}</span>
          </router-link>

          <transition name="fade">
            <div v-if="!pendingCategories && !categories.length">{{
                $t('Категорій не знайдено')
              }}
            </div>
          </transition>
        </div>
      </div>

      <div class="catalog__list" :class="{_loading: pendingList}">
        <BasePreloader v-if="pendingList"/>

        <transition-group tag="div"
                          name="list-fade"
                          class="catalog__list-inner">
          <Card v-for="(item, index) in items"
                :key="`${item.id}_${index}`"
                :card="item"
                :isConstructor="item.is_constructor"
          />
          <div key="empty" v-if="!pendingList && !items.length" class="catalog__list-empty">{{
              $t('Товарів не знайдено')
            }}
          </div>
        </transition-group>

        <div v-if="page && page < totalPages"
             class="g-loadmore"
             @click.prevent="onLoadMoreItems"
        >
          <div class="g-loadmore-btn">
            <BasePreloader v-if="pendingList"/>
            <span>{{ $t('Показати більше') }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Card from './Card'
import {http} from '@/axios'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'Catalog',
  components: {Card},
  data() {
    return {
      items: [],
      categories: [],
      pendingCategories: true,
      pendingList: true,
      page: 0,
      totalPages: 0,
      error: null,
      pendingConstructor: false,
      constructor: null,
    }
  },
  computed: {
    ...mapState('settings', ['settings']),
    ...mapState('restaurants', ['active_restaurant']),
    activeRestaurantId() {
      let id = window.localStorage.getItem('active_restaurant_id') || null
      if (this.active_restaurant) {
        id = this.active_restaurant.id
      }
      return id
    },
    activeRouteRestaurantId() {
      return this.$route.params.restaurantId || null
    },
    getCategorySlug() {
      return this.$route.params.categorySlug ?? this.categories?.find(item => item?.slug)?.slug
    },
    getCategoryId() {
      return this.categories?.find(item => item?.slug === this.$route.params.categorySlug)?.id ?? '0'
    },
    isPizzaCategory() {
      return this.settings && Number(this.settings.pizzaCategoryId) === Number(this.getCategoryId)
    },
    is_selected_restaurant() {
      return JSON.parse(window.localStorage.getItem('is_selected_restaurant') || null) || false
    },
    availableCategory() {
      return this.categories && this.categories.find(item => item.slug === this.getCategorySlug)
    }
  },
  methods: {
    ...mapActions('restaurants', ['setActiveRestaurant']),
    loadConstructor() {
      this.pendingConstructor = true
      http.get(`/api/product/classic`)
        .then(({data}) => {
          this.constructor = data.data
        })
        .finally(() => {
          this.pendingConstructor = false
        })
    },

    loadCategories(restaurant_id) {
      this.pendingCategories = true

      let config = {
        params: {
          parent_id: 0
        }
      }

      if (restaurant_id) {
        config.params.restaurant_id = restaurant_id
      }

      return http.get(`/api/product/categories`, config)
        .then(({data}) => {
          this.categories = data.data
        })
        .finally(() => {
          this.pendingCategories = false
        })
    },

    load(shouldAdd) {
      if (this.availableCategory) {
        this.pendingList = true
        let page = (this.page || 0) + 1
        this.error = null

        http.get(`api/product/products-for-category`, {
          params: {
            slug: this.getCategorySlug,
            page: page,
            page_size: this.isPizzaCategory ? 11 : 12
          }
        })
          .then(({data}) => {
            if (shouldAdd) {
              this.items = this.items.concat(data.data)
            } else {
              let itemsArr = data.data
              if (this.isPizzaCategory && this.constructor) {
                this.constructor.is_constructor = true
                itemsArr.unshift(this.constructor)
              }
              this.items = itemsArr
            }

            this.page = data.meta.current_page
            this.totalPages = data.meta.total_pages
          })
          .catch((error) => {
            this.items = []
            this.page = 0
            this.totalPages = 0
            this.error = error
          })
          .finally(() => {
            this.pendingList = false
          })
      } else {
        this.items = []
        this.pendingList = false
        this.page = 0
        this.totalPages = 0
      }
    },
    onLoadMoreItems() {
      this.load(true)
    },
    async loadAll() {
      if (this.activeRouteRestaurantId != this.activeRestaurantId) {
        await this.setActiveRestaurant(this.activeRouteRestaurantId)
      }

      await this.loadCategories(this.activeRouteRestaurantId)
      await this.loadConstructor()
      this.load()

      if (!this.is_selected_restaurant) {
        this.$vModal.open('select-place')
      }
    }
  },
  created() {
    this.loadAll()
  },
  watch: {
    '$route'(to, from) {

      let toCategory = to.params.categorySlug
      let fromCategory = from.params.categorySlug
      let toRestaurant = to.params.restaurantId
      let fromRestaurant = from.params.restaurantId

      if (toRestaurant !== fromRestaurant) {
        this.setActiveRestaurant(toRestaurant).then(async (restaurant_id) => {
          this.page = 0
          await this.loadCategories(restaurant_id)
          await this.loadConstructor()
          this.load()
        })
        return
      }

      if (toCategory !== fromCategory) {
        this.page = 0
        this.load()
      }
    }
  }
}
</script>

<style>

</style>
